module.exports = __webpack_public_path__ + "static/media/medicon.a47e3a89.png";